var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesPropDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 50,
    viewBox: "0 0 194 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3199 29.25L32.7599 45.61L49.21 29.25L65.6499 45.61L82.0899 29.25L96.5899 43.68L111.1 29.25L127.54 45.61L143.99 29.25L160.43 45.61L176.87 29.25L193.19 45.49L191.37 47.31L176.87 32.88L160.43 49.24L143.99 32.88L127.54 49.24L111.1 32.88L96.5899 47.32L82.0899 32.88L65.6499 49.24L49.21 32.88L32.7599 49.24L16.3199 32.88L1.80994 47.31L-6.10352e-05 45.49L16.3199 29.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3201 0L32.7601 16.36L49.2101 0L65.6501 16.36L82.0901 0L95.1301 12.98L95.1401 16.62L82.0901 3.63L65.6501 19.99L49.2101 3.63L32.7601 19.99L16.3201 3.63L1.81012 18.06L0.00012207 16.23L16.3201 0Z",
    fill: "#4643C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesPropDark);
export default __webpack_public_path__ + "static/media/features-prop-dark.de8c77b9f53ed9dc73e11b6b11184275.svg";
export { ForwardRef as ReactComponent };